// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"f2baa1bf","721":"f5dbb830","919":"37e653c4"}[chunkId] + ".chunk.js";
};